// extracted by mini-css-extract-plugin
export default {"tags_title":"AnimalInfoBlock_tags_title__YfWJh","animalInfo_details":"AnimalInfoBlock_animalInfo_details__GSclj","spin":"AnimalInfoBlock_spin__PIm2s"};